<template>

    <div>
        <div
            v-if="!updating"
        >
            <button
                class="btn btn-xs btn-default pull-right"
                @click="updating = true"
                v-tooltip="'Bedrag aanpassen'"
            >
                <i class="mdi mdi-pencil"></i>
                <span class="sr-only">Bedrag aanpassen</span>
            </button>
            {{ value | toCurrency }}
        </div>
        <div
            v-else
            class="flex"
        >
            <money
                class="form-control"
                :value="getProperValue()"
                @input="setProperValue($event)"
                v-bind="money"
            ></money>

            <button type="button"
                @click="updateAmount"
                class="btn btn-info btn-xs btn-flat"
            >
                <i class="mdi mdi-content-save"></i>
            </button>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import {Money} from 'v-money';

export default {

    components: {
        Money,
    },

    data() {
        return {
            updating: false,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '€ ',
                suffix: '',
                precision: 2,
                masked: false
            },
        }
    },

    methods: {
        updateAmount() {
            axios.patch(this.updateUrl, {amount: this.value})
            .then(() => {
                this.$snotify.success("Het bedrag is aangepast");
                this.updating = false;
                this.$emit('valueUpdated', this.value);
            })
            .catch(() => this.$snotify.error("Er is een fout opgetreden bij het aanpassen van het bedrag"));
        },

        getProperValue() {
            return this.value / 100;
        },

        setProperValue(newValue) {
            this.value = newValue * 100;
        },
    },

    name: "TasksUpdateAmount",

    props: {
        value: { required: true },
        updateUrl: { required: true },
    },

}

</script>
